import angular from 'angular'

function NominasCfdiEmpresaNomina($http) {
  this.get = function (idProyecto, idNomina, opciones) {
    return $http.get('/api/nominas/cfdi/empresa/nomina', {
      params: {
        id_proyecto: idProyecto,
        id_nomina: idNomina,
        pdf: (opciones && opciones.pdf) ? 1 : 0,
        xml: (opciones && opciones.xml) ? 1 : 0,
      },
      download: true,
    });
  };
}

angular.module('nominas.cfdi')
  .service('NominasCfdiEmpresaNomina', NominasCfdiEmpresaNomina);



// WEBPACK FOOTER //
// ./src/nominas/cfdi/services/NominasCfdiEmpresaNomina.js